import TimezoneContent from './component/TimezonContent';
import EventEmitter from './common/eventEmitter';
import { setLuxonDateTime } from './component/LuxonDateTime';
import { defaultConfig } from './common/const';
import { getParent } from './common/dom';
import { getServerLocalTimeDiff, setDateTime } from './common/util';
import type { ITimezoneConfig } from '../interface/ITimezone';

abstract class AbstractTimezone {
  $parent: HTMLElement | null;

  config: ITimezoneConfig;

  startTime: number;

  serverLocalTimeDiff: number;

  emitter: EventEmitter;

  content!: TimezoneContent;

  constructor() {
    this.config = {...defaultConfig, ...window?.timezoneConfig};
    this.serverLocalTimeDiff = getServerLocalTimeDiff(this.config.serverTime!);
    this.startTime = setDateTime(this.config?.serverTime);
    this.emitter = new EventEmitter();
    this.$parent = getParent(this.config) as HTMLElement;

    this.init();
  }

  abstract render(): void;

  async init() {
    await setLuxonDateTime();
    this.setTimzoneContent();
    this.render();
    this.addEvent();
  }

  setTimzoneContent() {
    this.content = new TimezoneContent({ 
      config: this.config, 
      startTime: this.startTime,
      serverLocalTimeDiff: this.serverLocalTimeDiff,
      emitter: this.emitter 
    });
  }

  addEvent() {}
}

export default AbstractTimezone;